/* Mega menu desktop: apertura al passaggio del mouse, al focus da tastiera e al primo tap su touch. */
(function () {
  var OPEN_DELAY = 80;
  var CLOSE_DELAY = 180;
  var desktop = window.matchMedia('(min-width: 1024px)');
  var current = null;
  var openTimer = null;
  var closeTimer = null;
  var lastPointer = 'mouse';

  function navbarBottom(item) {
    var bar = document.getElementById('navbar') || item.closest('nav');
    return Math.round(bar.getBoundingClientRect().bottom);
  }

  function setOpen(item, open) {
    var link = item.querySelector('.mm-link');
    item.classList.toggle('is-open', open);
    if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function open(item) {
    clearTimeout(closeTimer);
    if (current === item) return;
    if (current) setOpen(current, false);
    var panel = item.querySelector('.mm-panel');
    if (panel) panel.style.setProperty('--mm-top', navbarBottom(item) + 'px');
    current = item;
    setOpen(item, true);
    document.documentElement.classList.add('mm-open');
  }

  function close() {
    clearTimeout(openTimer);
    if (!current) return;
    setOpen(current, false);
    current = null;
    document.documentElement.classList.remove('mm-open');
  }

  function bind(item) {
    if (item._mmBound) return;
    item._mmBound = true;

    item.addEventListener('mouseenter', function () {
      if (!desktop.matches || lastPointer === 'touch') return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { open(item); }, current ? 0 : OPEN_DELAY);
    });

    item.addEventListener('mouseleave', function () {
      if (lastPointer === 'touch') return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(close, CLOSE_DELAY);
    });

    item.addEventListener('focusin', function () {
      if (desktop.matches) open(item);
    });

    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) closeTimer = setTimeout(close, CLOSE_DELAY);
    });

    // Su touch il primo tap apre il pannello, il secondo segue il link
    item.querySelector('.mm-link').addEventListener('click', function (e) {
      if (!desktop.matches || lastPointer !== 'touch') return;
      if (current !== item) {
        e.preventDefault();
        open(item);
      }
    });
  }

  function init() {
    document.querySelectorAll('.mm-item--parent').forEach(bind);
  }

  document.addEventListener('pointerdown', function (e) {
    lastPointer = e.pointerType || 'mouse';
    if (current && !current.contains(e.target)) close();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current) {
      var link = current.querySelector('.mm-link');
      close();
      if (link) link.focus();
    }
  });

  desktop.addEventListener('change', close);
  window.addEventListener('resize', function () {
    if (!current) return;
    var panel = current.querySelector('.mm-panel');
    if (panel) panel.style.setProperty('--mm-top', navbarBottom(current) + 'px');
  });
  // La home fullscreen chiude il menu quando cambia sezione
  document.addEventListener('fs:change', close);

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  window.megaMenu = { close: close };
})();
